import { useEffect, useState } from "react"
import Modal from "react-modal"
import Card from "@/common/cards/person/person"
import Details from "@/common/cards/person/details"
import { useArchiveContext } from "@/lib/contexts/archiveContext"
import Block from "@/components/wrappers/block"
import Close from "@/components/common/icons/close"
import styles from "./archive-personnel.module.css"

export default function ArchivePersonnel({ block }) {
  const store = useArchiveContext()
  const [isActive, setActive] = useState(false)
  const [person, setPerson] = useState(null)

  useEffect(() => {
    store.setList(block.attrs.list)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const handleKeyup = (event) => {
      if (event.keyCode === 27) {
        toggleModal(false)
      }
    }

    window.addEventListener("keyup", handleKeyup)

    return () => {
      window.removeEventListener("keyup", handleKeyup)
    }
  }, [])

  useEffect(() => {
    let list = block.attrs.list

    if (store.selected.length !== 0) {
      list = list.filter((section) => section.slug === store.selected[0])
    }

    store.setList(list)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.selected, store.phrase])

  const toggleModal = (isActive, person = null) => {
    if (isActive && String(person?.desc).length === 0) {
      return null
    }

    setActive(isActive)
    setPerson(person)
  }

  const list = store.list.length === 0 ? block.attrs.list : store.list

  const sections = list.map((section, key) => {
    return (
      <Section
        key={key}
        section={section}
        phrase={store.phrase}
        toggleModal={toggleModal}
      />
    )
  })

  return (
    <Block block={block}>
      {sections}
      <PersonModal
        person={person}
        toggleModal={toggleModal}
        isActive={isActive}
      />
    </Block>
  )
}

const Section = ({ section, phrase, toggleModal }) => {
  let persons = [...section.persons]

  if (phrase !== "") {
    persons = persons.filter((person) => {
      return person.name.toLowerCase().includes(phrase.toLowerCase())
    })
  }

  if (persons.length === 0) {
    return null
  }

  let cards = persons.map((person, key) => {
    return <Card person={person} key={key} toggleModal={toggleModal} />
  })

  return (
    <div id={section.slug} className="mb-16">
      <h2 className="mb-8 break-words">{section.heading}</h2>
      <ul className="grid grid-cols-2 gap-4 md:gap-10 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5">
        {cards}
      </ul>
    </div>
  )
}

const PersonModal = ({ person, isActive, toggleModal }) => {
  Modal.setAppElement("#__next")

  const customStyles = {
    overlay: {
      display: "flex",
      backgroundColor: "rgba(0, 0, 0, .5)",
      zIndex: 1000,
      alignItems: "center",
      justifyContent: "center"
    }
  }

  return (
    <Modal
      id="person-modal"
      isOpen={isActive}
      style={customStyles}
      shouldReturnFocusAfterClose={true}
      shouldCloseOnOverlayClick={true}
      className={styles.modal}>
      <div className="close-wrapper" onClick={() => toggleModal(false)}>
        <div className="close">
          <Close className="icon" />
        </div>
      </div>
      <Details person={person} />
    </Modal>
  )
}
